import React from 'react';
import styled from 'styled-components';

import { ReactComponent as LogoWhiteC } from '../../../assets/logo-white.svg';
import { ReactComponent as InstagramIconC } from '../../../assets/socialmedia/instagram.svg';
import { ReactComponent as TwitterIconC } from '../../../assets/socialmedia/twitter.svg';
import { ReactComponent as LinkedInIconC } from '../../../assets/socialmedia/linkedin.svg';

import { colours, spacing } from '../../../theme';

const FooterElem = styled.footer`
  background: ${colours.black};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.small} 0;
  position: absolute;
  bottom: 0;
  width: 100vw;
  max-height: 2em;
`;

const IconContainer = styled.div`
  display: flex;
  min-width: 10vw;
  justify-content: space-between;
  margin: 0 ${spacing.small};
  max-height: 3em;
`;

const LogoWhite = styled(LogoWhiteC)`
  max-height: 2.5em;
`;

const InstagramIcon = styled(InstagramIconC)`
  max-height: 2em;
`;

const TwitterIcon = styled(TwitterIconC)`
  max-height: 2em;
`;

const LinkedInIcon = styled(LinkedInIconC)`
  max-height: 2em;
`;

export const Footer = ({ setTitle }) => {
  return (
    <FooterElem>
      <IconContainer>
        <a
          href="https://www.squarecircleagency.com/"
          title="Square Circle"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LogoWhite />
        </a>
      </IconContainer>
      <IconContainer>
        <a
          href="https://www.instagram.com/squarecircleagency/"
          title="Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <InstagramIcon />
        </a>
        <a
          href="https://twitter.com/SquareCircleSQ"
          title="Twitter"
          target="_blank"
          rel="noopener noreferrer"
        >
          <TwitterIcon />
        </a>
        <a
          href="https://www.linkedin.com/company/squarecircleagency/"
          title="Linked In"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedInIcon />
        </a>
      </IconContainer>
    </FooterElem>
  );
};

export default Footer;
